<template>
  <div id="xxx_main">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../assets/img/返回箭头.png" class="nav-img">
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">注册</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="" class="nav-img none">
      </div>
    </div>

    <div class="ub ub-ver">
      <div class="info-block">
        <div class="ub ub-pc info-item">
          <img src="../assets/img/手机.png" class="img">
          <input type="text" placeholder="请输入您的手机号码">
        </div>

        <div class="ub ub-pc info-item">
          <img src="../assets/img/密码.png" class="img">
          <input type="password" placeholder="请输入登录密码">
        </div>

        <div class="ub ub-pc info-item">
          <img src="../assets/img/密码.png" class="img">
          <input type="password" placeholder="确认登录密码">
        </div>

        <div class="ub">
          <div class="ub ub-pc ub-f1 info-item">
            <img src="../assets/img/图形验证码.png" class="img">
            <input type="text" placeholder="图形验证码" class="input-verify">
          </div>
          <img src="../assets/img/验证码图片.png" class="verify-img">
        </div>

        <div class="ub">
          <div class="ub ub-pc ub-f1 info-item">
            <img src="../assets/img/数字验证码.png" class="img">
            <input type="text" placeholder="手机验证码" class="input-verify">
          </div>
          <div class="obtain-btn">获取</div>
        </div>
        <span class="register-btn">立即注册</span>
    </div>
      </div>
      
  </div>
</template>

<script>
export default {
  data() {
    return {
      data_name: "xxxx"
    };
  },

  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    }
  }
};
</script>

<style lang="scss" scoped>
.info-block {
  padding: 0.8rem 0.8rem 0 0.8rem;
  input {
    background-color:transparent;
    margin-left: 0.8rem;
    border: 0;
    outline: 0;
    font-size: 1rem;
    height: 1.5rem;
  }
  .info-item {
    padding: 0.2rem 0.8rem;
    border: 1px solid #9dcef7;
    height: 2rem;
    margin-bottom: 1rem;
    border-radius: 0.3rem;
    .img {
      width: 1.5rem;
      height: 1.5rem;
    }
    .input-verify{
      background-color:transparent;
      margin-left: 0.8rem;
      border: 0;
      outline: 0;
      font-size: 1rem;
      height: 1.5rem;
      width: 10rem;
    }
  }
  .verify-img {
    height: 2.5rem;
    width: 6rem;
    margin: 0 0 0 1rem;
  }
  .obtain-btn {
    background-color: #e92162;
    width: 6rem;
    height: 2.5rem;
    text-align: center;
    line-height: 2.5rem;
    color: #fff;
    border-radius: 0.3rem;
    margin: 0 0 0 1rem;
  }
  .register-btn {
    display: block;
    height: 2.5rem;
    color: #fff;
    line-height: 2.5rem;
    background-color: #e92162;
    text-align: center;
    font-size: 1.2rem;
    margin-top: 0.7rem;
    border-radius: 0.3rem;
  }
}

</style>